import { PRODUCT_MODE_MAP } from '@src/utils/constants';
import { getMetricShortName } from '@src/utils/metrics';

export const getMetricsMapping = () => {
  return {
    bufferingRatio: getMetricShortName({
      metricKey: 'RebufferingRatio',
      context: PRODUCT_MODE_MAP.EI,
    }),
    videoStartFailure: getMetricShortName({
      metricKey: 'VideoStartFailuresTech',
      context: PRODUCT_MODE_MAP.EI,
    }),
    bitrateKbps: getMetricShortName({
      metricKey: 'Bitrate',
      context: PRODUCT_MODE_MAP.EI,
    }),
    joinFailure: getMetricShortName({
      metricKey: 'JoinFailures',
      context: PRODUCT_MODE_MAP.EI,
    }),
    connectionInducedBufferingRatio: getMetricShortName({
      metricKey: 'ConnectionInducedRebufferingRatio',
      context: PRODUCT_MODE_MAP.EI,
    }),
    playbackFailure: getMetricShortName({
      metricKey: 'VideoPlaybackFailuresTech',
      context: PRODUCT_MODE_MAP.EI,
    }),
  };
};

export const formatNumber = (number) => {
  if (isNaN(number)) return number;
  return Number(Math.round(number * 1000) / 1000);
};
